import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import Panel from 'components/atoms/GefMui/Panel/Panel';
import PaperWithToolbar from 'components/atoms/GefMui/PaperWithToolbar';
import PAGES from 'constants/pages';
import { subheaders } from 'features/common/Subheader/constants';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { resetFormCriteria } from 'features/views/unlockedClients/actions';
import { getContextUser } from 'features/views/userContext/selectors';

import Toolbar from './components/Toolbar';
import UnlockedClientsOverview from './components/UnlockedClientsOverview';
import UnlockedClientsOverviewTable from './components/UnlockedClientsOverviewTable';

const UnlockedClients = () => {
	const dispatch = useDispatch();

	useEffect(
		() => () => {
			dispatch(resetFormCriteria());
		},
		[dispatch],
	);

	const contextUser = useSelector(getContextUser);
	const subheaderTitle = useRenderSubheaderTitle({
		contextUser,
		pageTitle: getLabelMessage('unlockedClients:unlockedClientsOverviewHeader'),
	});

	return (
		<Panel screenId={PAGES.unlockedClients.id} screenName={PAGES.unlockedClients.name}>
			<PaperWithToolbar
				subheaderTitle={subheaderTitle}
				subTitle={getLabelMessage('unlockedClients:unlockedClientsTableRecords1YearOldOnly')}
				toggledElement={<UnlockedClientsOverview />}
				toolbar={<Toolbar />}
				collapsibleProps={{ id: subheaders.unlockedClients, initiallyOpen: true }}
			>
				<UnlockedClientsOverviewTable />
			</PaperWithToolbar>
		</Panel>
	);
};

export default UnlockedClients;
